import {Descriptions, Modal} from 'antd';
import React from 'react';
import {useModel} from '@umijs/max';
import {formatDateTime} from '@/utils/date';

type PersonalInfoModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const cardTypeMap: Record<number, string> = {
  1: '身份证',
  2: '护照',
  3: '军官证',
};

const PersonalInfoModal: React.FC<PersonalInfoModalProps> = ({open, onOpenChange}) => {
  const {initialState} = useModel('@@initialState');
  const currentUser = initialState?.currentUser;
  const currentIdentity = currentUser?.identities?.find((i) => i.pid === currentUser.pid);

  return (
    <Modal
      title="个人信息"
      open={open}
      onCancel={() => onOpenChange(false)}
      footer={null}
      width={500}
      destroyOnClose
    >
      <Descriptions column={1} bordered size="small" style={{marginTop: 16}}>
        <Descriptions.Item label="姓名">{currentUser?.name ?? '-'}</Descriptions.Item>
        <Descriptions.Item label="手机号">{currentUser?.phoneNumber ?? '-'}</Descriptions.Item>
        <Descriptions.Item label="邮箱">{currentUser?.email ?? '-'}</Descriptions.Item>
        <Descriptions.Item label="部门">{currentIdentity?.deptName ?? '-'}</Descriptions.Item>
        <Descriptions.Item label="角色">{currentIdentity?.roleNames?.join('、') ?? '-'}</Descriptions.Item>
        <Descriptions.Item label="证件类型">
          {currentUser?.cardType ? (cardTypeMap[currentUser.cardType] ?? '-') : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="证件号码">{currentUser?.cardId ?? '-'}</Descriptions.Item>
        <Descriptions.Item label="地址">{currentUser?.address ?? '-'}</Descriptions.Item>
        <Descriptions.Item label="上次登录时间">{formatDateTime(currentUser?.lastLoginTime)}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default PersonalInfoModal;
